import PubSub from "underpub-js";
import gsap from "gsap";
import slick from "slick-carousel";
import CardUnitType from "../../../elements/Cards/CardUnitType/CardUnitType";

var ListingUnitTypes = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingUnitTypes',
	};

	$.extend(true, this.options, options);

};

ListingUnitTypes.prototype.init = function () {

	var self = this;

	self.$slides = self.options.$el.find(`.${self.options.baseClass}__items`);
	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.initCarousel();

	// self.$filtersDropdown = self.options.$el.find(`.${self.options.baseClass}__filters__dropdown`);
	// self.$items = self.options.$el.find(`.${self.options.baseClass}__item`)

	// self.$filtersDropdown.on("change", () => self.updateFilters());

};

ListingUnitTypes.prototype.initCarousel = function() {

	var self = this;

	// initialize slides after the cloning is complete
	self.$slides.on('init', function(slick) {
		self.initSlides();
	});
	// init elements that slick may add or move/clone after resize
	PubSub.subscribe("Sitewide:resized", function() {
		self.initSlides();
	});

	self.$slides.slick({
		prevArrow: self.$arrowPrev,
		nextArrow: self.$arrowNext,
		dots: false,
		infinite: true,
		// variableWidth: true,
		centerMode: false,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 420,
				settings: {
					centerPadding: '30px',
					centerMode: true,
					slidesToShow: 1,
					variableWidth: false,
				}
			},
		]
	});

};

// This method is needed when Slick redraws the slides.
// Slick copies the event listeners from the original slide, so we remove those here.
ListingUnitTypes.prototype.initSlides = function() {

	const self = this;

	let $slides = self.$slides.find(`.el-CardUnitType`);

	$slides.each(function(){

		// remove previously attached event listeners, because slick will clone event listeners
		$(this).off();

		// initialize the cloned CardUnitType
		var component = new CardUnitType({
			$el: $(this)
		});
		component.init();

	});

};

/*
ListingUnitTypes.prototype.updateFilters = function () {
	const self = this;

	const selectedFilterValue = self.$filtersDropdown.val();

	console.log(selectedFilterValue);

	if (selectedFilterValue.length) {
		self.$activeItems = self.$items.filter((i, el) => {
			return $(el).find(`[data-unit-category="${selectedFilterValue}"]`).length;
		});
	} else {
		self.$activeItems = self.$items;
	}

	gsap.timeline({
			defaults: {
				ease: "expo.out",
				duration: 1,
			}
		})
		.to(self.$items, {
			duration: .4,
			opacity: 0,
		})
		.set(self.$items.not(self.$activeItems), {
			display: "none",
		})
		.set(self.$activeItems, {
			display: "block",
		})
		.to(self.$activeItems, {
			opacity: 1
		})
};
*/

export default ListingUnitTypes;